window.livewire.on('homeSearch', () => {

    document.querySelector('#side-nav').classList.remove('visible');
    document.querySelector('#side-nav-mask').classList.remove('visible');

});

window.livewire.on('changeConversation', (mem_id) => {

    window.history.pushState('data', 'Title', '/messagerie/detail/' + mem_id);
    document.querySelector('#nabTopBar').classList.add('xs-display-none');
    document.querySelector('#chat-messages').scrollTop = document.querySelector('#chat-messages').scrollHeight;
    document.querySelector('#sendmessage_text').focus();

});

window.livewire.on('closeConversation', () => {

    document.querySelector('#nabTopBar').classList.remove('xs-display-block');

});


window.livewire.on('sendMessage', () => {

    document.querySelector('#chat-messages').scrollTop = document.querySelector('#chat-messages').scrollHeight;

});
